export enum Roles {
  admin = 'admin',
  productManager = 'productManager',
  teamMember = 'teamMember',
  client = 'client',
}

// `projectManager` is the same job under its old name, so anything deciding by role reads the two as one.
export const normalizeRole = (role: string): string => (role === 'projectManager' ? Roles.productManager : role);

export type OptionsType = { value?: string; label?: string };

export enum TabsType {
  pastSprints = 'PAST-SPRINTS',
  currentSprint = 'CURRENT-SPRINT',
  overview = 'OVERVIEW',
}

export type TabType = TabsType.currentSprint | TabsType.pastSprints | TabsType.overview;

/** The two questions the Reporting page answers: what you still owe, and what you filed. */
export enum SprintReportTab {
  toReport = 'toReport',
  completed = 'completed',
}

/** The two halves of the incident log: the queue of what is still ours to deal with, and the archive. */
export enum IncidentTab {
  open = 'open',
  closed = 'closed',
}

export enum ProductTabsType {
  brief = 'BRIEF',
  detailed = 'DETAILED',
}

export enum ReportTabsType {
  new = 'NEW',
  approved = 'APPROVED',
}

export type TabNavState = {
  activeTab: TabsType;
};

export interface ProductsReportingNavState extends TabNavState {
  productsFilter: string[];
  clientFilter?: string[];
  chapterFilter: string;
  /** More than one status can be filtered at once, so the state carries a list, not a single value. */
  statusFilter: string[];
}

export type ReportTabNavState = {
  activeTab: ReportTabsType;
};

export enum TimeValueType {
  fullDay = 8,
  halfDay = 4,
}
